module.exports = __webpack_public_path__ + "img/Disability-Icon.b8fae875.png";